import { UserLoggedSlice } from "./auth";

export const storeRedux: any = {
  reducer: {
    [UserLoggedSlice.name]: UserLoggedSlice.reducer
  }
};
